/**
 * @author: lv.chen
 * @date: 2025/4/27
 * @desc: 简单版标签列表组件，用于纯展示
 */
import React, { useRef } from 'react';
import classnames from 'classnames';
import ListRenderGuide from '@gp/components/ListRenderGuide';
import GeneralTag from '@gp/components/GeneralTag';
import useFlexSpacingLayoutInfo, {
  FLEX_ITEM_HORIZONTAL_SPACING,
  FLEX_ITEM_VERTICAL_SPACING,
} from '@gp/hooks/useFlexSpacingLayoutInfo';

import type { IBaseProps } from '@home/types/common';
import type { IGeneralTagFormatter } from '@gp/components/GeneralTag';

import './index.scss';

interface IGeneralTagListProps extends IBaseProps {
  tags?: string[] | null;
  formatter?: IGeneralTagFormatter;
}

const GeneralTagList: React.FC<IGeneralTagListProps> = (props) => {
  const { style, className, tags, formatter } = props;

  const root = useRef<HTMLUListElement | null>(null);

  const flexItemsLayoutInfos = useFlexSpacingLayoutInfo(root, tags as any);

  return (
    <ListRenderGuide list={tags}>
      <ul ref={root} style={style} className={classnames('dbg-general-tag-list', className)}>
        {tags?.map((tag, tagIndex) => {
          const { marginRight = FLEX_ITEM_HORIZONTAL_SPACING, marginBottom = FLEX_ITEM_VERTICAL_SPACING } =
            flexItemsLayoutInfos[tagIndex] || {};
          return (
            <li key={tag} style={{ marginRight, marginBottom }} className="dbg-general-tag-item">
              <GeneralTag text={tag} formatter={formatter} />
            </li>
          );
        })}
      </ul>
    </ListRenderGuide>
  );
};

export default GeneralTagList;
